const socialImages = {
    pinterest: require("./Pinterest.png"),
    apple: require("./apple.png"),
    facebook: require("./facebook.png"),
    github: require("./github.png"),
    google: require("./google.png"),
    instagram: require("./instagram.png"),
    linkden: require("./linkden.png"),
    snapchat: require("./snapchat.png"),
    twitter: require("./twitter.png"),
    youtube: require("./youtube.png"),
    tiktok: require("./tiktok.png"),
    clubhouse:require("./clubhouse.png"),
    discord:require("./discord.png"),
    dribbble:require("./dribbble.png"),
    figma:require("./figma.png"),
    medium:require("./medium.png"),
    reddit:require("./reddit.png"),
    signal:require("./signal.png"),
    spotify:require("./spotify.png"),
    telegram:require("./telegram.png"),
    tumbir:require("./tumblr.png"),
    twitch:require("./twitch.png"),
    vk:require("./vk.png")
}

export default socialImages